export default __webpack_public_path__ + "static/media/BA15.62c335ea.jpg";